module.exports = "/_next/static/images/photoAnaBurlac-f048cca5461d51706858a4d8e5025b6d.webp";